import React from "react";
import { useHistory } from "react-router-dom";
import Connect from "../../store/config/connect";
import imgPreCadastroHeader from "../../images/pre-cadastro-img.webp";
import regulamento from "../../docs/Bravecto_Advantage_Club_2.0__SAMPLE_Terms_and_Conditions_-_Traduzido_(002).pdf";
import "./PreCadastroStep2.css";

const PreCadastroStep2 = (props) => {
  const history = useHistory();

  const handleNovoClube = () => {
    window.location.href = "https://clubedevantagensbravecto.com.br/";
  };

  const handleClubeAtual = () => {
    history.push("/cadastrar");
  };

  return (
    <div className="pre-cadastro-step2-container">
      <div className="custom-header">
        <div className="header-content">
          <div className="logo-container">
            <span className="bravecto-logo"></span>
          </div>
        </div>
        <div className="header-svg">
          <img src={imgPreCadastroHeader} alt="" />
        </div>
      </div>
      <div className="pre-cadastro-step2-content">
        <div className="main-message">
          <h1 className="main-title">
            Temos um novo clube especialmente voltado para pessoas do Estado do
            Rio de Janeiro!
          </h1>
          <p className="main-subtitle">
            Nele, ao comprar nos parceiros participantes, você garante descontos
            exclusivos na sua próxima compra.
          </p>
        </div>

        <div className="main-card">
          <div className="card-accent-bar"></div>
          <div className="card-content">
            <h2 className="card-title">Clube de Vantagens Bravecto® 2.0:</h2>
            <ol className="steps-list">
              <li className="step-item">Cadastre sua nota fiscal.</li>
              <li className="step-item">
                Ganhe níveis e desbloqueie descontos.
                <div className="step-explanation">
                  Cada compra aprovada aumenta seu nível.
                </div>
                <div className="step-explanation">
                  Nos níveis 2, 3 e 4, você recebe cupons, e no nível 4 o
                  desconto máximo fica sempre ativo!
                </div>
              </li>
              <li className="step-item">Aproveite seus cupons!</li>
            </ol>

            <div className="buttons-container">
              <button className="btn-novo-clube" onClick={handleNovoClube}>
                Novo Clube de Vantagens Bravecto® 2.0
              </button>
              <button className="btn-clube-atual" onClick={handleClubeAtual}>
                Atual Clube de Vantagens Bravecto®
              </button>
            </div>
          </div>
        </div>

        <div className="footer">
          <a
            className="regulamento-link"
            href={regulamento}
            target="_blank"
            rel="noopener noreferrer"
          >
            Confira o Regulamento Clube de Vantagens Bravecto 2.0.
          </a>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ auth, helper }) => {
  return {
    auth,
    helper,
  };
};

export default Connect(mapStateToProps)(PreCadastroStep2);

